import React, { Component } from "react";

import "./LoadingSpinner.scss";

const LoadingSpinner = ({ loading }) => {
  return (
    <div className={`${loading ? "show" : "hide"}`}>
      <div className="loading-spinner"></div>
    </div>
  );
};

export default LoadingSpinner;
